<template>
  <v-flex xs12 sm10 md6 xl4>
    <div class="vertical-center-container">
      <div class="mr-3">
        <v-select
          label="Select action"
          :items="actions"
          v-model="selectedAction"
          item-value="value"
          return-object
          prepend-inner-icon="list"
          clearable
          @click:clear="clearSelectedAction"
          :color="$store.state.global.pages.allocationStaging.color"
        >
          <template slot="item" slot-scope="data">
            <v-list-tile-action>
              <v-icon :color="data.item.color">{{ data.item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title>{{ data.item.text }}</v-list-tile-title>
          </template>
          <template
            slot="selection"
            slot-scope="data"
          >{{ !!selectedCount ? `${data.item.text} for ${selectedCount} batch allocations` : `${data.item.text}`}}</template>
        </v-select>
      </div>
      <div>
        <v-btn
          :color="$store.state.global.pages.allocationStaging.color"
          flat
          @click="confirmAction()"
        >Confirm</v-btn>
      </div>

      <!-- DIALOG CONFIRMATION -->
      <v-dialog
        v-model="dialog"
        max-width="700px"
        @keydown.esc="dialog = false"
        lazy
        v-if="userAuthClass"
      >
        <confirm-action
          :selectedAction="selectedAction"
          :selectedCount="selectedCount"
          :loading="loading"
          @confirm="setSelectedBatchAllocations"
          @close="dialog = false"
        ></confirm-action>
      </v-dialog>

      <!-- EXPORT DIALOG -->
      <v-dialog v-model="exportDialog" max-width="400px" @keydown.esc="exportDialog = false" lazy>
        <export-csv :selected="selected" :selectedAll="selectedAll" @close="exportDialog = false"></export-csv>
      </v-dialog>
    </div>
  </v-flex>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import AllocationService from "@/services/requests/allocationService";

// MIXINS
import StagingViewMixin from "../mixins/stagingViewMixin";
import FormatDates from "@/services/mixins/formatDates";

// COMPONENTS
import ConfirmAction from "../actions/confirmAction";
import ExportCsv from "./exportCsv";
export default {
  mixins: [StagingViewMixin, FormatDates],
  components: {
    ConfirmAction,
    ExportCsv
  },
  props: {
    selectedCount: Number
  },
  data() {
    return {
      dialog: false,
      exportDialog: false,
      selectedAction: {},
      // notes: "",
      loading: false
    };
  },
  computed: {
    selected: Store.getSet({ store: "allocationStaging", prop: "selected" }),
    selectedAll() {
      return this.$store.state.allocationStaging.selectedAll;
    }
  },
  methods: {
    clearSelectedAction() {
      this.selectedAction = {};
    },
    confirmAction() {
      if (!this.selectedCount) {
        this.snack({ color: "yellow", text: "No batches are selected!" });
        this.dialog = false;
        return;
      }
      if (!Object.keys(this.selectedAction).length) {
        this.snack({ color: "yellow", text: "No action was selected!" });
        this.dialog = false;
        return;
      } else {
        if (this.selectedAction.value.label == "export") {
          this.exportDialog = true;
        } else {
          this.dialog = true;
        }
      }
    },

    setSelectedBatchAllocations(notes) {
      if (!this.selectedCount) {
        this.snack({ color: "yellow", text: "No batches are selected!" });
        return;
      }
      if (!Object.keys(this.selectedAction).length) {
        this.snack({ color: "yellow", text: "No action was selected!" });
        return;
      } else {
        this.update(this.selected, notes);
      }
    },
    update(selected, notes) {
      selected = selected.map(item => item.id);
      this.updateBatchAllocations(selected, notes);
    },
    updateBatchAllocations(batchHeaders, notes) {
      this.loading = true;
      const updateBatchAllocationsData = {
        field: this.selectedAction.value.field,
        notesField: `${this.selectedAction.value.label}Notes`,
        notes: notes,
        value: this.selectedAction.value.value,
        batchHeaders: batchHeaders
      };
      AllocationService.updateBatches(updateBatchAllocationsData)
        .then(result => {
          for (const batchHeader of result.data.result.batchHeaders) {
            this.$store.commit("allocationStaging/updateArrayStateById", {
              prop: "batches",
              editedValue: batchHeader
            });
          }
          this.loading = false;
          this.dialog = false;
          this.snack({
            color: "green",
            text: `${result.data.result.affectedRows} Allocation Batches were updated`
          });
        })
        .catch(err => {
          this.loading = false;
          this.snackError();
          console.log(err);
        });
    }
  }
};
</script>

<style>
</style>
